import { Box, Link, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface ErrorProps {
  errorMessageKey?: string;
}
export const GenericErrorComponent = (props: ErrorProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        pt: 30,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img src='/public/assets/images/dog_empty.svg' width='60%' />
      <Typography
        sx={{
          pt: 10,
        }}
      >
        <FormattedMessage
          id={props.errorMessageKey ?? 'common.error.generic.rich'}
          values={{
            contactLink: (text) => (
              <Link
                target='_top'
                rel='noopener noreferrer'
                href={'mailto:support@mybrightlink.org'}
                variant='body1'
              >
                {text}
              </Link>
            ),
          }}
        />
      </Typography>
    </Box>
  );
};
